import { render } from "./CreateDriver.vue?vue&type=template&id=1565ffa2"
import script from "./CreateDriver.vue?vue&type=script&lang=js"
export * from "./CreateDriver.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__